import type { PropsWithChildren } from 'react';

import classNames from 'classnames';

import * as styles from '../Pricing.css';

type Props = PropsWithChildren;

export const Tabs = ({ children }: Props) => {
  return (
    <div
      className={classNames(
        'flex flex-row p-1 gap-x-2 overflow-x-scroll',
        styles.tierTabsContainerBorder,
        styles.tierTabBackgroundColor,
      )}
    >
      {children}
    </div>
  );
};
